import React from 'react';
import { useTranslation } from 'react-i18next';

const AdvanceHeader = () => {
  // traslations
  const tLabels = useTranslation(["invoice\\invoice"]).t;

  return (
    <div className="text-muted font-weight-bold">
      <div className="row no-gutters">
        <div className="col col-sm-6">
          {tLabels("advanceHeader.description")}
        </div>
        <div className="col-auto col-sm-6 pl-3">
          <div className="row no-gutters">
            <div className="col-auto col-sm-6 order-1 order-sm-0 text-right text-sm-left">
              <span className="d-sm-none">/</span>
              {tLabels("advanceHeader.dueDate")}
            </div>
            <div className="col-auto col-sm-6 text-right">
              {tLabels("advanceHeader.amount")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdvanceHeader;
